import ApiClient from './client';

export const initApi = (store) => {
	let metaAsportUserContextId = document.head.querySelector("meta[name='asport-user-context-id']");
	metaAsportUserContextId = metaAsportUserContextId ? metaAsportUserContextId.getAttribute('content') : null;

	store.dispatch('user/setContextId', metaAsportUserContextId);
	store.dispatch('user/setContextName', window.userContextName);
	ApiClient.init(metaAsportUserContextId);
};
